module.exports = __webpack_public_path__ + "static/pickle-d831d9a076d0b39f71ebfc3ff65e1a53.svg";